(function () {
  'use strict';
  if (window.__sidonieBuyNowOnlyProduct) return;
  window.__sidonieBuyNowOnlyProduct = true;

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function buildDirectCheckout(button) {
    var variantId = null;
    var qtyInput = null;

    if (button.matches('[data-sh-sig-modal-buynow]')) {
      variantId = button.getAttribute('data-variant-id');
      var modal = button.closest('[data-sh-sig-modal]');
      qtyInput = modal ? modal.querySelector('[data-sig-qv-qty-input]') : null;
    } else {
      var variantField = document.getElementById('sh-variant-id');
      variantId = variantField ? variantField.value : null;
      var form = document.getElementById('sh-product-form');
      qtyInput = form ? form.querySelector('.sh-qty-input') : null;
    }

    if (!variantId) return null;
    variantId = String(variantId).split('/').pop();
    if (!/^\d+$/.test(variantId)) return null;

    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    return shopRoot() + 'cart/' + variantId + ':' + quantity;
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.sh-buynow-btn, [data-sh-sig-modal-buynow]')
      : null;

    if (!button || button.disabled) return;

    var checkoutUrl = buildDirectCheckout(button);
    if (!checkoutUrl) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    button.disabled = true;
    button.classList.add('is-loading');
    window.location.assign(checkoutUrl);
  }, true);
})();

(function () {
  'use strict';
  if (window.__sidonieReviewPopupPersistentDismiss) return;
  window.__sidonieReviewPopupPersistentDismiss = true;

  var DISMISSED_KEY = 'sidonie_review_popup_dismissed_v1';
  var swipeStartX = null;
  var swipePointerId = null;

  function isDismissed() {
    try {
      return window.localStorage.getItem(DISMISSED_KEY) === '1';
    } catch (err) {
      return document.cookie.indexOf(DISMISSED_KEY + '=1') !== -1;
    }
  }

  function rememberDismissal() {
    try {
      window.localStorage.setItem(DISMISSED_KEY, '1');
    } catch (err) {
      document.cookie = DISMISSED_KEY + '=1; Max-Age=31536000; Path=/; SameSite=Lax';
    }
  }

  function suppressPopup() {
    var popup = document.getElementById('sh-review-popup');
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.innerHTML = '';
    popup.style.setProperty('display', 'none', 'important');
    popup.setAttribute('aria-hidden', 'true');
  }

  if (isDismissed()) {
    suppressPopup();
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target && event.target.closest
      ? event.target.closest('.sh-review-popup__close')
      : null;

    if (!closeButton) return;

    rememberDismissal();
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    suppressPopup();
  }, true);

  document.addEventListener('pointerdown', function (event) {
    var card = event.target && event.target.closest
      ? event.target.closest('.sh-review-popup__card')
      : null;
    if (!card) return;
    swipeStartX = event.clientX;
    swipePointerId = event.pointerId;
  }, true);

  document.addEventListener('pointerup', function (event) {
    if (swipeStartX === null || swipePointerId !== event.pointerId) return;
    var deltaX = event.clientX - swipeStartX;
    swipeStartX = null;
    swipePointerId = null;

    if (deltaX <= 50) return;

    rememberDismissal();
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    suppressPopup();
  }, true);
})();
